import { PropsWithChildren } from 'react';
import { TObject } from '@types';

type TProps = {
	columnSpan?: string | number;
	rowSpan?: string | number;
	justifySelf?: string;
	alignSelf?: string;
	placeSelf?: string;
	style?: TObject;
	className?: string;
}

export const Item = (props:PropsWithChildren<TProps>) => {
	const {
		children,
		className,
		columnSpan,
		rowSpan,
		justifySelf,
		alignSelf,
		placeSelf,
		style = {}
	} = props;

	const getStyles = () => {
		const cellStyles:TObject = { ...style };
		if (columnSpan) {
			cellStyles.gridColumn = `span ${columnSpan}`;
		}
		if (rowSpan) {
			cellStyles.gridRow = `span ${rowSpan}`;
		}
		if (justifySelf) {
			cellStyles.justifySelf = justifySelf
		}
		if (alignSelf) {
			cellStyles.alignSelf = alignSelf
		}
		if (placeSelf) {
			cellStyles.placeSelf = placeSelf
		}
		return cellStyles;
	}

	return (
		<div data-testid={'@Grid-Cell'} style={getStyles()} className={className}>
			{children}
		</div>
	);
}
